<template>
  <div class="week-calendar-header">
    <div class="week-calendar-corner"></div>
    <div
      v-for="(day, index) in days"
      :key="`${day.date}-${index}`"
      class="week-calendar-header-cell week-calendar-header-cell--day"
      :class="{ 'week-calendar-header-cell--today': isToday(day.date) }"
    >
      <div class="week-calendar-header-weekday">{{ day.weekday }}</div>
      <div class="week-calendar-header-date">{{ day.displayDate }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'WeekCalendarHeader',
  props: {
    days: {
      type: Array,
      default: () => [],
    },
    nowMoment: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isToday(date) {
      return moment(date).isSame(this.nowMoment, 'day');
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/variables';

.week-calendar-header {
  display: grid;
  grid-column: 1 / 3;
  grid-row: 1 / 2;
  grid-template-columns: 50px repeat(7, minmax(0, 1fr));
  position: sticky;
  top: 2.2rem;
  background-color: $light-color;
  z-index: 101;
  border-top: $border-width solid $border-color;
  border-right: $border-width solid $border-color;
  height: 100%;
  align-items: stretch;
}

.week-calendar-corner {
  background-color: $light-color;
  height: 100%;
  min-height: 4rem;
}

.week-calendar-header-cell {
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 0;
}

.week-calendar-header-cell--day {
  border-radius: 0;
  background-color: $light-color;
  border-bottom: $border-width solid $border-color;
  border-left: $border-width solid $border-color;
  min-height: 4rem;
  padding: 0.75rem $layout-spacing-sm;
  align-items: center;
  height: 100%;
}

.week-calendar-header-cell--today {
  border-bottom-color: $border-color;
  border-left-color: $border-color;
  padding: 0.5rem $layout-spacing-sm;
}

.week-calendar-header-weekday {
  font-weight: 400;
  font-size: 0.5rem;
  color: $gray-color;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.week-calendar-header-date {
  color: $gray-color-dark;
  font-size: $font-size-lg;
  font-weight: 400;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.week-calendar-header-cell--today .week-calendar-header-date {
  background-color: rgba($primary-color, 0.12);
  color: darken($primary-color, 10%);
  font-weight: 500;
}

@media screen and (max-width: $size-lg) {
  .week-calendar-header {
    grid-template-columns: 3.5rem repeat(7, minmax(0, 1fr));
  }
}
</style>
